import React, {useContext} from "react";
import classNames from "classnames";
import ChevronRightIcon from "@heroicons/react/solid/ChevronRightIcon";
import FormContext from "../form-context";
import Form from "../index";
import _get from "lodash/get";
import {prefixFieldNames} from "../utils";

export default function SchemaBindingConfig({
                                                id,
                                                name,
                                                label,
                                                description,
                                                className,
                                                prefix,
                                                fieldsets = [],
                                                onFieldChange = () => {},
                                            }) {
    const context = useContext(FormContext);

    const openBindingEditor = () => {
        const currentValues = {...context.values};
        const prefixedFieldsets = prefixFieldNames(fieldsets, prefix || name);

        context.setContext({
            showChildForm: true,
            childForm: (
                <Form
                    id="schema_binding_editor"
                    layout="panel-style"
                    className="h-full"
                    heading={label || "Configure Binding"}
                    fieldsets={prefixedFieldsets}
                    parentContext={context}
                    selectedNode={context.selectedNode}
                    values={context.values}
                    original={context.original}
                    actions={[
                        {label: "Cancel", back: true},
                        {label: "Done", primary: true, icon: "check"},
                    ]}
                    onSubmit={(e) => {
                        const allValues = context.values;
                        const updatedConfig = _get(allValues, name, {});
                        onFieldChange(e, name, updatedConfig);
                        context.setContext({showChildForm: false});
                    }}
                    onActionClick={(e, action) => {
                        if (action.back) {
                            context.setContext({
                                values: currentValues,
                                showChildForm: false,
                            });
                        }
                    }}
                    onFieldChange={(e, fieldName, fieldValue) => {
                        onFieldChange(e, fieldName, fieldValue)
                    }}
                />
            ),
        });
    };

    return (
        <>
            <div className={classNames("relative", className)}>
                <div className="rounded border border-gray-500 shadow-button px-3 pt-2 pb-1.5 grow">
                    <div className="flex mb-1 justify-between">
                        <label htmlFor={id || name} className="block text-sm font-semibold text-gray-700">
                            {label || "Configure Binding"}
                        </label>
                    </div>
                    <div className="relative">
                        <div
                            className="absolute top-0 left-0 right-0 h-[40px] -mt-[33px] flex items-center justify-between cursor-pointer"
                            onClick={openBindingEditor}>
                            <span className="grow"/>
                            <ChevronRightIcon className="w-5 h-5 shrink-0 text-gray-500"/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}